var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBench(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_1796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.02712 12.6719C0.495873 13.4062 0.730248 14.0781 1.71462 14.0781H3.324C4.05837 20.2969 9.46462 25.2188 15.8396 25.2188C19.574 25.2188 22.949 23.5469 25.2615 20.9219C25.7927 20.3281 25.7146 19.5625 25.1677 19.1719C24.6209 18.7812 23.9646 18.9219 23.4959 19.4375C21.6365 21.5312 18.9021 22.8438 15.8396 22.8438C10.6521 22.8438 6.43337 19.0469 5.73025 14.0781H7.40212C8.37087 14.0781 8.62087 13.4062 8.10525 12.6875L5.324 8.71875C4.90212 8.10938 4.24587 8.09375 3.80837 8.71875L1.02712 12.6719ZM6.43337 4.28125C5.90212 4.875 5.98025 5.625 6.52712 6.01562C7.08962 6.40625 7.74587 6.29688 8.21462 5.76562C10.0896 3.6875 12.8084 2.375 15.8396 2.375C21.0271 2.375 25.2615 6.17188 25.949 11.1406H24.2771C23.3084 11.1406 23.074 11.8125 23.5896 12.5469L26.3709 16.5C26.7927 17.1094 27.449 17.125 27.8865 16.5L30.6677 12.5625C31.199 11.8125 30.9646 11.1406 29.9802 11.1406H28.3709C27.6365 4.92188 22.2302 0 15.8396 0C12.1365 0 8.7615 1.65625 6.43337 4.28125Z",
    fill: "#888888",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_1796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.5699,
    height: 25.2344,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBench);
export default __webpack_public_path__ + "static/media/bench.7c3d842e86b27e38c0043e7cd1438aba.svg";
export { ForwardRef as ReactComponent };